import React from "react";
import Modal from "./Modal";
import Button from "../FormElements/Button";
import "./styling/ReleaseNotesModal.css";

// Renders one section per unseen release entry (newest first) — a user who
// skipped several releases sees each of them. Closing without acknowledging
// (backdrop, "Remind me later") re-shows the modal on the next sign-in; only
// the acknowledge button suppresses it until the next release.
const ReleaseNotesModal = ({ show, entries, onClose, onAcknowledge }) => {
  if (!entries || entries.length === 0) return null;

  return (
    <Modal
      show={show}
      onCancel={onClose}
      header="What's New"
      footerClass="release-notes__footer"
      footer={
        <>
          <Button inverse onClick={onClose}>
            Remind Me Later
          </Button>
          <Button onClick={onAcknowledge}>
            Don't Show Until Next Update
          </Button>
        </>
      }
    >
      <div className="release-notes">
        {entries.map((entry) => (
          <section key={entry.version} className="release-notes__entry">
            <p className="release-notes__meta">
              Version {entry.version}
              <span className="release-notes__meta-separator">·</span>
              {entry.date}
            </p>

            <ul className="release-notes__list">
              {entry.features.map((feature, idx) => (
                <li key={idx} className="release-notes__item">
                  <span className="release-notes__item-dot" aria-hidden="true" />
                  <div className="release-notes__item-body">
                    <strong className="release-notes__item-heading">
                      {feature.heading}
                    </strong>
                    <p className="release-notes__item-description">
                      {feature.description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>

            {entry.note && <p className="release-notes__note">{entry.note}</p>}
          </section>
        ))}
      </div>
    </Modal>
  );
};

export default ReleaseNotesModal;
